<!--
 * @FileDescription: 网格拖拽排序功能
 * @Date: 2023-02-07 14:09:43
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->

<!--
  使用方式：<Goods :data="goods" @isTop="onIsTopGood" @delete="onDeleteGood" @select="onSelect" @end="onEnd" />

  数据格式：[{ id: i, spuCode: HGGGFFFTT, price: 10.00, top: true, imgUrl: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg' }]

  暴露方法：
  /**
  * 点击置顶ICon的回调事件
  *
  * @param {Object} good 当前点击的商品
  */
  onIsTopGood(good) {},

  /**
  * 点击删除ICon的回调
  *
  * @param {Object} good 当前点击的商品
  */
  onDeleteGood(good) {},

  /**
  * 选中商品时触发的事件回调
  *
  * @param {Array} selectIds 当前选中的商品IDs
  */
  onSelect(selectIds) {},

  /**
  * 拖拽结束后触发的事件回调
  *
  * @param {Array} selectIds 当前选中的商品IDs
  * @param {Array} sortIds 当前列表排序后的IDs（未包含置顶元素）
  * @param {Array} ids 当前列表排序后的IDs
  */
  onEnd(selectIds, sortIds, ids) {}
-->

<template>
  <ul id="kaka-drag-goods" class="goods">
    <li v-for="good in data" :key="good.kkProductId" :data-good-id="good.kkProductId" :class="[{ 'kaka-drag-good': good.top === 0 || !good.top }, 'good']">
      <div :class="['good-img', { 'no-drop': good.top === 1 }, { 'kaka-drag-good-img': good.top === 0 || !good.top }]">
        <img :src="good.images" alt="good.png" />
        <div v-if="[3,4].includes(good.status)" class="sold-out f-c-c">缺货</div>
      </div>
      
      <p v-if="showPriority" class="priority f--c">
        <span class="label">优先级: </span>
        <el-input size="mini" v-model="good.priority" maxlength="5" placeholder="请输入" @blur="changePriority(good)"></el-input>
      </p>

      <p class="spu">
        <span class="label">SPU: </span>
        <span class="value">{{ good.spuCode }}</span>
      </p>

      <p class="price">
        <span class="label">$</span>
        <span class="value">{{ good.price }}</span>
      </p>

      <img v-if="good.top === 1" src="~@/assets/img/istop.png" class="istop-img" alt="istop.png" />

      <div class="footer">
        <div>
          <el-tooltip content="复制SPU" placement="top">
            <i class="iconfont icon-fuzhi1" @click="(event) => handleCopy(good.spuCode, event)" />
          </el-tooltip>
          <el-tooltip v-if="showFixed" content="置顶" placement="top">
            <i :class="['fixed-nail', 'iconfont', 'icon-igw-l-sign', 'nail', { active: good.top === 1 }]" @click="(event) => onIsTopGood(good, event)" />
          </el-tooltip>
          <el-tooltip v-if="showDelete" content="删除" placement="top">
            <i class="iconfont icon-a-delete-bin-6-line5" @click="(event) => onDeleteGood(good, event)" />
          </el-tooltip>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { copy } from '@/utils/copy'
import { Sortable } from 'sortablejs'

export default {
  props: {
    data: {
      type: Array,
      required: false,
      default: () => []
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    avoidImplicitDeselect: {
      type: Boolean,
      required: false,
      default: false
    },
    showFixed: {
      type: Boolean,
      required: false,
      default: true
    },
    showDelete: {
      type: Boolean,
      required: false,
      default: true
    },
    showPriority: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      sortable: null
    }
  },
  mounted() {
    this.drag()
  },
  methods: {
    /**
     * 初始化拖拽功能
     * 插件中文文档: https://www.itxst.com/sortablejs/neuinffi.html
     * 插件官方文档: https://github.com/SortableJS/Sortable/tree/master/plugins/MultiDrag
     */
    drag() {
      let element = document.getElementById('kaka-drag-goods')
      if (element) {
        this.sortable = new Sortable(element, {
          handle: '.kaka-drag-good-img', // 句柄（鼠标需按住有该类的元素才可以拖拽）
          draggable: '.kaka-drag-good', // 可拖拽的元素（必须拥有该类名的元素才能被拖拽）
          animation: 500, // 拖拽的动画执行时间
          dataIdAttr: 'data-good-id', // 自定义CSS属性（sortable.toArray()可获取该值）
          multiDrag: true, // 是否开启多选拖拽（注意：需要注册多选拖拽功能）
          selectedClass: 'selected', // 多选拖拽时的选中样式
          disabled: this.disabled, // 是否禁止拖拽
          avoidImplicitDeselect: this.avoidImplicitDeselect, // 不可以点击盒子外的区域取消选中
          fallbackTolerance: 3, // 兼容手机端
          // 选中项目时的回调
          onSelect: (event) => {
            this.$emit('select', this.getGoodIds(event.items))
          },
          // 取消选择项目时调用
          onDeselect: (event) => {
            this.$emit('select', this.getGoodIds(event.items))
          },
          onEnd: (event) => {
            let ids = []
            if (event.newIndex !== event.oldIndex) {
              if (event.items.length) {
                ids = [...this.getGoodIds(event.items)]
              } else {
                ids.push(Number.parseInt(event.item.getAttribute('data-good-id')))
              }
              this.$emit(
                'end',
                ids,
                this.sortable.toArray().map((item) => Number.parseInt(item)),
                this.getIsTopIds()
              )
            }
          }
        })
      }
    },

    /**
     * 销毁排序实例
     */
    async destroySortable() {
      await this.sortable.destroy()
      this.drag()
    },

    /**
     * 获取当前所有已选项的Ids
     *
     * @param {Array} arr 已选项数组
     * @return {Array} 返回已选项IDs
     */
    getGoodIds(arr) {
      return arr.map((item) => Number.parseInt(item.getAttribute('data-good-id')))
    },

    /**
     * 获取当前列表排序后的IDs
     */
    getIsTopIds() {
      let element = document.getElementById('kaka-drag-goods')
      if (element) {
        return Array.from(element.children).map((item) => {
          return Number.parseInt(item.getAttribute('data-good-id'))
        })
      } else {
        return []
      }
    },

    /**
     * 点击置顶ICon的回调事件
     */
    onIsTopGood(good, event) {
      event.stopPropagation()
      this.$emit('isTop', good)
    },

    /**
     * 点击删除ICon的回调
     */
    onDeleteGood(good, event) {
      event.stopPropagation()
      this.$emit('delete', good)
    },

    /**
     * 复制KaKaOrderId
     */
    handleCopy(spuCode, event) {
      event.stopPropagation()
      copy(spuCode)
    },
  
    /**
     * 失去焦点修改优先级
     */
    changePriority(good) {
      this.$emit('changePriority', {
        update: [good.id],
        orderNum: +good.priority,
        oldPriority: good.oldPriority || undefined
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.goods {
  display: grid;
  grid-gap: 12px 12px;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 142px);
  overflow: auto;

  .good {
    display: flex;
    position: relative;
    width: 142px;
    height: 205px;
    padding: 8px;
    padding-bottom: 10px;
    overflow: hidden;
    flex-direction: column;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    &:hover {
      cursor: no-drop;
      .good-img {
        &.no-drop {
          cursor: no-drop;
        }
      }
      .footer {
        display: block;
      }
    }

    .good-img {
      flex: 1;
      overflow: hidden;
      cursor: move;
      border-radius: 4px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .sold-out {
        width: 80%;
        height: 22px;
        border-radius: 4px;
        background-color: #f9f4f7;
        color: #8B93A3;
        line-height: 22px;
        text-align: center;
        position: absolute;
        bottom: 6px;
        left: 0;
        right: 0;
        margin: auto;
        opacity: .8;
        z-index: 1;
      }
    }
    .spu,
    .price,
    .priority {
      color: #10141d;
      font-size: 12px;
      margin-top: 5px;
    }
    .priority {
      margin-top: 4px;
      .label {
        flex-shrink: 0;
        margin-right: 6px;
      }
    }

    .istop-img {
      position: absolute;
      top: 0;
      right: 0;
      width: 32px;
    }

    .footer {
      display: none;
      position: absolute;
      left: 0;
      bottom: 0px;
      width: 100%;
      height: 29px;
      line-height: 29px;
      text-align: center;
      background: rgba(0, 0, 0, 0.58);
      i {
        display: inline-block;
        margin-right: 12px;
        color: #fff;
        font-weight: 400;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
        &.icon-fuzhi1:hover,
        &.icon-igw-l-sign:hover {
          color: #99c41c;
        }
        &.icon-a-delete-bin-6-line5:hover {
          color: #f56c6c;
        }
      }
      .active {
        color: #99c41c;
        transform: rotate(-42deg);
      }
    }
  }
}

.selected {
  background: rgba(153, 196, 28, 0.06) !important;
  border: 1px solid #99c41c !important;
  z-index: 1 !important;
}
</style>
